import React from "react";
import Footer from "../../components/user/Footer";
import Carousel from "../../components/user/home/Carousel";
import KenapaJMD from "../../components/user/home/KenapaJMD";
import StatsCounter from "../../components/user/home/StatsCounter";
import FiturJMD from "../../components/user/home/FiturJMD";
import BeritaTerbaru from "../../components/user/home/BeritaTerbaru";
import CTASection from "../../components/user/home/CTASection";
import Testimoni from "../../components/user/home/Testimoni";
import FAQ from "../../components/user/home/FAQ";
import { Link } from "react-router-dom";

const RunningText = () => {
	return (
		<div role="region" aria-label="Pengumuman" className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-r from-green-600 to-green-500 shadow-md z-[999]">
			<style
				dangerouslySetInnerHTML={{
					__html: `
@keyframes marquee {
	0% { transform: translateX(100%); }
	100% { transform: translateX(-100%); }
}
.animate-marquee {
	animation: marquee 15s linear infinite;
}
`,
				}}
			/>
			<div className="py-1.5 flex items-center overflow-hidden whitespace-nowrap">
				<div
					className="inline-block animate-marquee"
					style={{ animation: "marquee 15s linear infinite" }}
				>
					<Link to="/skl" className="w-full">
						<span className="text-white font-semibold text-sm flex items-center gap-2">
							🎓 Pengumuman Kelulusan Siswa/i Madrasah DIY — Silahkan klik
							disini untuk melihat informasi selengkapnya
						</span>
					</Link>
				</div>
			</div>
		</div>
	);
};

function Home() {
	return (
		<>
			{/* <Header /> */}
			<RunningText />

			{/* Hero Carousel */}
			<section aria-label="Hero" className="mt-9">
				<Carousel />
			</section>

			<section aria-label="Konten Utama" className="max-w-8xl mx-auto">
				{/* Kenapa JMD Section */}
				<KenapaJMD />

				{/* Stats Counter */}
				<StatsCounter />

				{/* Fitur Section */}
				<FiturJMD />

				{/* Berita Terbaru */}
				<BeritaTerbaru />

				{/* CTA Section */}
				<CTASection />

				{/* Testimoni */}
				<Testimoni />

				{/* FAQ */}
				<FAQ />
			</section>

			{/* Footer */}
			<Footer />
		</>
	);
}

export default Home;
